/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { BilancioEnte } from '@ideapa/app-shared-bilancio-ente';
import { BilancioEnteDto, ResultDto } from '@ideapa/common-dto';
import { TipoBilancio } from '@ideapa/common-utils';
import { map, Observable } from 'rxjs';
import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class BilancioEnteApiClient extends BaseCRUDApiClient<BilancioEnteDto> {
  baseUrl = this.config.apiEndpoint + '/bilancio-ente';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  canImport() {
    return this.http.get<boolean>(`${this.baseUrl}/can-import`);
  }

  // importExcelFile(file: File, esercizio: number) {
  //   const fd = new FormData();
  //   fd.append('file', file);
  //   return this.http.post<ResultDto>(
  //     this.baseUrl + '/import-excel/' + esercizio,
  //     fd
  //   );
  // }
  importExcelFile(file: File, esercizio: number, tipo: TipoBilancio) {
    this._pagedCache.clear();
    const fd = new FormData();
    fd.append('file', file);
    fd.append('tipo', tipo);
    return this.http.post<ResultDto>(
      this.baseUrl + '/import-excel/' + esercizio,
      fd
    );
  }

  exportBilancioPdf(body: { codiceProspetto: string }) {
    return this.http
      .post(`${this.baseUrl}/export-bilancio-pdf`, body, {
        responseType: 'arraybuffer',
      })
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  setDefaultBilancioEnte(idBilancioEnte: number): Observable<BilancioEnte> {
    this._pagedCache.clear();
    return this.http.get<BilancioEnte>(
      `${this.baseUrl}/set-default-bilancio-ente/${idBilancioEnte}`
    );
  }


  unsetDefaultBilancioEnte(idBilancioEnte: number): Observable<BilancioEnte> {
    this._pagedCache.clear();
    return this.http.get<BilancioEnte>(
      `${this.baseUrl}/unset-default-bilancio-ente/${idBilancioEnte}`
    );
  }

  updateTotali(idBilancio: number) {
    this._pagedCache.clear();
    return this.http.get<BilancioEnte>(
      `${this.baseUrl}/update-totali/${idBilancio}`
    );
  }

  importBilancioCep() {
    this._pagedCache.clear();
    return this.http.get<BilancioEnte>(`${this.baseUrl}/import-bilancio-cep`);
  }
}
